class ColetorConfigDetails {
    constructor($scope) {
        this.$apply = $scope.$apply.bind($scope)
    }

    ultimoArquivo() {
        const ultimoArquivo = this.coletorConfig.ultimoArquivo
        const diretorio = this.coletorConfig.diretorio

        const replaced = ultimoArquivo.replace(diretorio, "")

        if (["/", "\\"].includes(replaced.charAt(0))) {
            return replaced.substr(1)
        }

        return replaced
    }

    getIconClassForOperacao() {
        return `fa-${this.operacaoDisplayName.toLowerCase()}`
    }

    get operacaoDisplayName() {
        return this.coletorConfig.operacao.toLowerCase().capitalize()
    }

    get documentoDisplayName() {
        return this.coletorConfig.documento == 'CTE' ? 'CT-e' : 'NF-e'
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('coletorConfigDetails', {
        controller: ['$scope', ColetorConfigDetails],
        bindings: {
            coletorConfig: '<',
            onEditConfig: '&',
            onRemoveConfig: '&',
            loading: '<'
        },
        template: `
            <div class="well well-xs">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="pull-right">
                            <button 
                                class="btn btn-xs btn-link"
                                ng-disabled="$ctrl.loading"
                                ng-click="$ctrl.onEditConfig({$event: $event, coletorConfig: $ctrl.coletorConfig})">
                                <i class="fa fa-edit"></i>
                            </button>

                            <button 
                                class="btn btn-xs btn-link"
                                ng-disabled="$ctrl.loading" 
                                ng-click="$ctrl.onRemoveConfig({$event: $event, coletorConfig: $ctrl.coletorConfig})">

                                <span ng-hide="$ctrl.loading">
                                    <i class="fa fa-trash text-danger"></i>
                                </span>

                                <span ng-show="$ctrl.loading">
                                    <i class="fa fa-spinner fa-spin text-danger"></i>
                                </span>
                            </button>
                        </div>

                        <h3>
                            {{$ctrl.coletorConfig.empresa.razaoSocial | limitToDots: 40}} 
                            <small class="text-muted">{{$ctrl.coletorConfig.empresa.raizCnpj | cpfCnpj}}</small>
                        </h3>
                    </div>

                    <div class="col-xs-12 text-muted">
                        <span>
                            <span style="margin-right: 10px;">
                                <i tooltip="Operação configurada: {{ $ctrl.operacaoDisplayName }} de {{ $ctrl.documentoDisplayName }}"
                                class="fa"
                                ng-class="$ctrl.getIconClassForOperacao()">
                                </i> {{ $ctrl.documentoDisplayName }}
                            </span>

                            <span>
                                <i tooltip="Diretório configurado" class="fa fa-folder"></i> {{ $ctrl.coletorConfig.diretorio }}
                            </span>
                        </span>

                        <span class="text-muted" ng-if="$ctrl.coletorConfig.ultimoArquivo">
                            <br/>
                            <i tooltip="Último arquivo enviado" class="fa fa-file"></i> {{ $ctrl.ultimoArquivo() }}
                        </span>

                        <span class="text-danger" ng-if="$ctrl.coletorConfig.status == 'DIRETORIO_INVALIDO'">
                            <br/>
                            <i class="fa fa-exclamation-triangle"></i>
                            A pasta configurada não existe.
                        </span>

                        <span class="text-danger" ng-if="$ctrl.coletorConfig.status == 'DIRETORIO_INACESSIVEL'">
                            <br/>
                            <i class="fa fa-exclamation-triangle"></i>
                            A pasta configurada esta inacessível.
                        </span>
                    </div>
                </div>
            </div>
        `
    })
